

import axios from "axios"
import configuration from '../configuration.json'

/**
 * Handle Session timeout for HTTP calls
 * In case of invalid session, the interceptor will refresh the session
 */
export default function interceptor(store, router) {

    axios.interceptors.request.use(
        config => {

            if (config.url == configuration.sessionUrl) {
                config.headers.Authorization = `Bearer ${store.state.token}`;
            }
            else {
                config.headers.Authorization = `Bearer ${store.state.sessiontoken}`;
            }

            config.headers["x-api-key"] = configuration.apikey;


            return config;

        }
    );

    /**
   * Handle response comming from the server
   */
    axios.interceptors.response.use(
        //pass response when no error happens
        response => { 
            return response; 
        },
        //handle error in case there is a problem
        function (error) {
            return handleError(error);
        }
    );

    /**
     * In case of an 401 Not authenticated or 440 session expired error,
     * the application will redirect to the login page.
     * 
     * @param {*} error The error received from the backend (Axios object)
     */
    async function handleError(error) {
        if (error.response != undefined && (error.response.status === 440 || error.response.status === 401)) {
            
            sessionStorage.setItem("originalRoute", router.currentRoute.fullPath);
            let port = (location.port != "" && location.port != 0) ? `:${location.port}` : "";
            window.location.href = `${configuration.loginUrl}&redirect_uri=https://${location.hostname}${port}/callback/&state=state`;
        }
    }
}
